/**
 * 文章列表组件
 * 用于展示文章卡片预览，包含文章标题、发布时间及缩略图占位
 * 根据 componentsData.type === 7 条件渲染，支持新旧版本数据结构的样式兼容
 * 
 * @prop {Object} componentsData - 组件配置数据
 * @prop {Object} componentsData.content - 内容配置项
 * @prop {string} componentsData.content.bg_color - 背景颜色
 * @prop {Object} componentsData.content.bg_img - 背景图片对象，picview 为图片预览地址
 * @prop {boolean} componentsData.content.bg_value - 是否启用背景图片
 * @prop {Object} componentsData.content.paddingData - 内边距配置 { top, left }
 * @prop {Object} componentsData.content.marginData - 外边距配置 { top, left }（旧版兼作内边距与圆角）
 * @prop {Object} componentsData.content.radiusData - 圆角配置 { top, bottom }
 * @prop {number} componentsData.content.marginData.topRadius - 顶部圆角（旧版）
 * @prop {number} componentsData.content.marginData.bottomRadius - 底部圆角（旧版）
 * @prop {string} componentsData.content.title_color - 标题文字颜色
 * @prop {number} componentsData.content.title_size - 标题文字大小（px）
 * @prop {boolean} componentsData.content.time_value - 是否显示发布时间
 * @prop {string} componentsData.content.time_color - 时间文字颜色
 * @prop {string} componentsData.content.dec_color - 装饰线渐变颜色
 * @prop {boolean} componentsData.content.version - 版本标识，true 为新版数据结构，false/undefined 为旧版
 * 
 */
<!-- 文章列表 -->
<template>
    <div
        v-if="componentsData.type == 7"
        class="bg-div"
        :style="
            componentsData.content.version
                ? {
                      ...(componentsData.content.bg_color && {
                          backgroundColor: componentsData.content.bg_color,
                      }),
                      ...(componentsData.content.bg_img.picview &&
                          componentsData.content.bg_value && {
                              backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                          }),
                      padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                      margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                      borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                  }
                : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div class="container">
            <div class="card">
                <div class="card-left">
                    <div
                        :style="`color: ${componentsData.content.title_color};font-size: ${componentsData.content.title_size}px;`"
                    >
                        文章标题
                    </div>
                    <div
                        v-if="componentsData.content.time_value"
                        :style="`color: ${componentsData.content.time_color}`"
                    >
                        2026-04-01
                    </div>
                </div>
                <div class="card-right"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    data() {
        return {};
    },
};
</script>

<style scoped>
.card {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.card-left {
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 13px;
}
.card-right {
    width: 122px;
    height: 80px;
    background: #c9d0e7;
    border-radius: 5px;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>